exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Member-module__tooltip___3txSY span{color:#b4bac3}.Member-module__tooltip-menu___1bRzp button{display:block;font-size:14px}.Member-module__invited___2NqTD,.Member-module__settings___1PEd3{position:absolute;width:35px;height:35px;top:0;left:0;border-radius:100%;color:#fff;display:grid;justify-content:center;align-items:center}.Member-module__settings___1PEd3{background:rgba(8,39,233,.5);opacity:0;transition:.2s;z-index:2}.Member-module__settings___1PEd3:hover{opacity:1}.Member-module__invited___2NqTD{background:rgba(8,39,233,.5)}", ""]);

// exports
exports.locals = {
	"tooltip": "Member-module__tooltip___3txSY",
	"tooltip-menu": "Member-module__tooltip-menu___1bRzp",
	"invited": "Member-module__invited___2NqTD",
	"settings": "Member-module__settings___1PEd3"
};